var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "el-timeline",
        { attrs: { reverse: "" } },
        _vm._l(_vm.versionList, function (version, index) {
          return _c("Versioning-TimelineItem", {
            key: index,
            attrs: { version: version },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }